import React from 'react';
import Base from './Base';
import SelectAsync from 'react-select/async';

export default class ImportExcel extends Base {
    constructor(props) {
        super(props);
        this.state = {
            type: props.Type,
            companyId: props.CompanyId,
            buildingId: props.BuildingId,
            caller: props.Caller,
            file: '',
            loading: true,
            fields: [],

            mainMoeinCode: 0,
            mainTafsilCode: 0,
            mainTafsilType: -1,

            bedMoeinCode: 0,
            bedTafsilCode: 0,
            bedTafsilType: -1,

            besMoeinCode: 0,
            besTafsilCode: 0,
            besTafsilType: -1,

            isBankTransaction:false,
            version: this.uuidv4(),

            templateId: null,
            title: '',

            checkMobileDuplicated: true,
            checkNationalIdDuplicated: true,
        }
        this.state.fields = this.getFields();
    }
    componentDidMount() {
    }
    uploadFile(event) {
        var _this = this;
        let file = event.target.files[0];
        if (file) {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                _this.state.file = reader.result;
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        }
    }
    getFields() {
        var t = [];
        if (this.state.type === 2) {
            t = [
                { type: 'text', enable: true, name: 'Name', caption: 'نام', index: '' },
                { type: 'text', enable: true, name: 'GroupCode', caption: 'کد گروه مشتریان', index: '' },
                { type: 'text', enable: true, name: 'BranchCode', caption: 'کد شعبه', index: '' },
                { type: 'text', enable: true, name: 'NationalId', caption: 'کد/شناسه ملی', index: '' },
                { type: 'text', enable: true, name: 'EconomicCode', caption: 'کد اقتصادی', index: '' },
                { type: 'text', enable: true, name: 'Type', caption: 'نوع شخص', index: '' },
                { type: 'text', enable: true, name: 'ZipCode', caption: 'کدپستی', index: '' },
                { type: 'text', enable: true, name: 'PasportNo', caption: 'شماره گذرنامه', index: '' },
                { type: 'text', enable: true, name: 'Mobile', caption: 'موبایل', index: '' },
                { type: 'text', enable: true, name: 'Phone', caption: 'شماره تماس', index: '' },
                { type: 'text', enable: true, name: 'Email', caption: 'آدرس ایمیل', index: '' },
                { type: 'text', enable: true, name: 'Address', caption: 'آدرس', index: '' },
                { type: 'text', enable: true, name: 'Gender', caption: 'جنسیت', index: '' },
                { type: 'text', enable: true, name: 'Marriage', caption: 'وضعیت تاهل', index: '' },
                { type: 'text', enable: true, name: 'ChildrenCount', caption: 'تعداد فرزندان', index: '' },
                { type: 'text', enable: true, name: 'EducationGrade', caption: 'مدرک تحصیلی', index: '' },
                { type: 'text', enable: true, name: 'FatherName', caption: 'نام پدر', index: '' },
                { type: 'text', enable: true, name: 'Shenasname', caption: 'شماره شناسنامه', index: '' },
                { type: 'text', enable: true, name: 'Sodor', caption: 'محل صدور', index: '' },
                { type: 'text', enable: true, name: 'BirthLocation', caption: 'محل تولد', index: '' },
                { type: 'text', enable: true, name: 'BirthDate', caption: 'تاریخ تولد', index: '' },
            ];
        }
        if (this.state.type === 3) {
            t = [
                { type: 'text', enable: true, name: 'Name', caption: 'نام', index: '' },
                { type: 'text', enable: true, name: 'TaxNumber', caption: 'شماره مالیاتی', index: '' },
                { type: 'text', enable: true, name: 'TaxRate', caption: 'نرخ مالیات', index: '' },
                { type: 'text', enable: true, name: 'Price', caption: 'قیمت واحد', index: '' },
                { type: 'text', enable: true, name: 'WarehouseCode', caption: 'کدانبار', index: '' },
                { type: 'text', enable: true, name: 'UnitCode', caption: 'کد مالیاتی واحد سنجش', index: '' },
                { type: 'text', enable: true, name: 'Barcode', caption: 'بارکد', index: '' },
                { type: 'text', enable: true, name: 'Description', caption: 'توضیحات', index: '' },
                { type: 'text', enable: true, name: 'Code', caption: 'کدکالا/خدمت', index: '' },
                { type: 'text', enable: true, name: 'GroupCode', caption: 'کد گروه کالا/خدمت', index: '' },
            ];
        }
        if (this.state.type === 4) {
            t = [
                { type: 'text', enable: true, name: 'documentTypeId', caption: 'کد نوع سند', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'document_description', caption: 'شرح سند', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'date', caption: 'تاریخ سند', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'bed', caption: 'مبلغ بدهکار', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'bes', caption: 'مبلغ بستانکار', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'moeinCode', caption: 'کدمعین', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'tafsilCode', caption: 'کدتفصیل', index: '', defaultValue: '' },
                {
                    type: 'text', enable: true, name: 'tafsilTypeCode', caption: 'کد نوع تفصیل', index: '', defaultValue: '', note: `
                    نوع تفصیل را بر اساس کد بندی زیر مشخص نمایید <br/>
                   0 - تفصیل های عادی
    1 - مشتریان و اشخاص
    2 - کالاها و خدمات
    3 - حساب بانکی
    4 - صندوق
    5 - مرکز درآمدی
    6 - مرکز هزینه ای
                    ` },
                { type: 'text', enable: true, name: 'description', caption: 'شرح آرتیکل', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'followNumber', caption: 'شماره پیگیری', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'followDate', caption: 'تاریخ پیگیری', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'count', caption: 'تعداد', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'currencyId', caption: 'کد واحد پولی', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'currencyAmount', caption: 'مقدار ارز', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'currencyRate', caption: 'نرخ ارز', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'note', caption: 'یادداشت سند', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'number', caption: 'شماره سند', index: '', defaultValue: '', note: 'در صورتیکه شماره سندی در اکسل وارد نفرمایید، در این صورت هر ردیف اکسل به عنوان یک سند در نظر گرفته خواهد شد' },
                { type: 'text', enable: true, name: 'number2', caption: 'شماره عطف سند', index: '', defaultValue: '' },
            ];
        }
        if (this.state.type === 5 || this.state.type === 6 || this.state.type === 7 || this.state.type === 8 ||
            this.state.type === 9 || this.state.type === 10 || this.state.type === 11 || this.state.type === 12) {

            var inp = '1';
            if (this.state.type == 5) inp = '1';
            if (this.state.type == 6) inp = '2';
            if (this.state.type == 7) inp = '3';
            if (this.state.type == 8) inp = '4';
            if (this.state.type == 9) inp = '5';
            if (this.state.type == 10) inp = '6';
            if (this.state.type == 11) inp = '7';
            if (this.state.type == 12) inp = '8';

            t = [
                { type: 'text', enable: true, name: 'inno', caption: 'سریال داخلی صورتحساب', index: '', defaultValue: '' },
                {
                    type: 'select', enable: true, name: 'ins', caption: 'موضوع', index: '', defaultValue: '1', items: [
                        { value: '1', label: '1 - اصلی' },
                        { value: '2', label: '2 - اصلاحی' },
                        { value: '3', label: '3 - ابطالی' },
                        { value: '4', label: '4 - برگشت از فروش' },
                    ]
                },
                {
                    type: 'select', enable: true, name: 'inty', caption: 'نوع', index: '', defaultValue: '1', items: [
                        { value: '1', label: '1 - نوع اول' },
                        { value: '2', label: '2 - توع دوم' },
                        { value: '3', label: '3 - نوع سوم' },
                    ]
                },
                {
                    type: 'text', enable: false, name: 'inp', caption: 'الگوی', index: '', defaultValue: inp
                },
                { type: 'text', enable: true, name: 'custname', caption: 'نام مشتری', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'nationalid', caption: 'کد/شناسه ملی', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'ecocode', caption: 'کد اقتصادی', index: '', defaultValue: '' },
                {
                    type: 'select', enable: true, name: 'tob', caption: 'نوع مشتری', index: '', defaultValue: '1', items: [
                        { value: '1', label: '1 - حقیقی' },
                        { value: '2', label: '2 - حقوقی' },
                        { value: '3', label: '3 - مشارکت مدنی' },
                        { value: '4', label: '4 - اتباع غیر ایرانی' },
                    ]
                },
                { type: 'text', enable: true, name: 'indatim', caption: 'تاریخ صورتحساب', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'irtaxid', caption: 'شماره مالیاتی مرجع', index: '', defaultValue: '' },
                {
                    type: 'select', enable: inp === '6', name: 'ft', caption: 'نوع پرواز', index: '', defaultValue: '1', items: [
                        { value: '1', label: '1 - داخلی' },
                        { value: '2', label: '2 - خارجی' },
                    ]
                },
                { type: 'text', enable: inp === '7', name: 'scln', caption: 'شماره پروانه گمرکی', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '7', name: 'scc', caption: 'کد گمرک محل اظهار فروشنده', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '7', name: 'cdcn', caption: 'شماره کوتاژ', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '7', name: 'cdcd', caption: 'تاریخ کوتاژ', index: '', defaultValue: '' },

                { type: 'text', enable: true, name: 'crn', caption: 'شناسه یکتای ثبت قرارداد', index: '', defaultValue: '' },

                { type: 'text', enable: inp === '5', name: 'billid', caption: 'شماره اشتراک/شناسه قبض بهره بردار', index: '', defaultValue: '' },

                {
                    type: 'select', enable: true, name: 'setm', caption: 'روش تسویه', index: '', defaultValue: '1', items: [
                        { value: '1', label: '1 - نقد' },
                        { value: '2', label: '2 - نسیه' },
                        { value: '3', label: '3 - نقد/نسیه' },
                    ]
                },
                { type: 'text', enable: true, name: 'tax17', caption: 'مالیات موضوع ماده 17', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'factorno', caption: 'شماره فاکتور', index: '', defaultValue: '' },

                { type: 'text', enable: inp === '8', name: 'lno', caption: 'شماره بارنامه', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '8', name: 'lrno', caption: 'شماره بارنامه مرجع', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '8', name: 'ocu', caption: 'کشور مبدا', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '8', name: 'oci', caption: 'شهر مبدا', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '8', name: 'dco', caption: 'کشور مقصد', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '8', name: 'dci', caption: 'شهر مقصد', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '8', name: 'tid', caption: 'شناسه ملی/ شماره ملی/ شناسه مشارکت مدنی/ کد فراگیر اتباع غیر ایرانی فرستنده', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '8', name: 'rid', caption: 'شناسه ملی/ شماره ملی/ شناسه مشارکت مدنی/ کد فراگیر اتباع غیر ایرانی گیرنده', index: '', defaultValue: '' },
                {
                    type: 'select', enable: inp === '8', name: 'lt', caption: 'نوع بارنامه', index: '', defaultValue: '1', items: [
                        { value: '1', label: '1 - جاده ای' },
                        { value: '2', label: '2 - ریلی' },
                        { value: '3', label: '3 - هوایی' },
                        { value: '4', label: '4 - دریایی' },
                    ]
                },
                { type: 'text', enable: inp === '8', name: 'cno', caption: 'شماره ناوگان', index: '', defaultValue: '' },
                { type: 'text', enable: inp === '8', name: 'did', caption: 'کد ملی/ کد فراگیر اتباع غیر ایرانی راننده) در حمل و نقل جاده ای(', index: '', defaultValue: '' },

                { type: 'text', enable: true, name: 'stufftaxnumber', caption: 'شماره مالیاتی کالا', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'unittaxnumber', caption: 'شماره مالیاتی واحد کالا', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'am', caption: 'تعداد', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'nw', caption: 'وزن خالص', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'fee', caption: 'قیمت', index: '', defaultValue: '0' },

                { type: 'text', enable: (inp === '2' || inp === '7'), name: 'cfee', caption: 'میزان ارز', index: '', defaultValue: '0' },
                { type: 'text', enable: (inp === '2' || inp === '7'), name: 'cut', caption: 'نوع ارز', index: '', defaultValue: 'IRR' },
                { type: 'text', enable: (inp === '2' || inp === '7'), name: 'exr', caption: 'نرخ برابری ارز با ریال', index: '', defaultValue: '0' },
                { type: 'text', enable: (inp === '2' || inp === '7'), name: 'ssrv', caption: 'ارزش ریالی کالا', index: '', defaultValue: '0' },
                { type: 'text', enable: (inp === '2' || inp === '7'), name: 'sscv', caption: 'ارزش ارزی کالا', index: '', defaultValue: '0' },

                //{ type: 'text', enable: true, name: 'prdis', caption: 'مبلغ قبل از تخفیف', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'dis', caption: 'مبلغ تخفیف', index: '', defaultValue: '0' },
                //{ type: 'text', enable: true, name: 'adis', caption: 'مبلغ بعد از تخفیف', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'vra', caption: 'نرخ مالیات', index: '', defaultValue: '10' },
                { type: 'text', enable: true, name: 'vam', caption: 'مبلغ مالیات بر ارزش افزوده', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'odt', caption: 'موضوع سایر مالیات و عوارض', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'odr', caption: 'نرخ سایر مالیات و عوارض', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'odam', caption: 'مبلغ سایر مالیات و عوارض', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'olt', caption: 'موضوع سایر وجود قانونی', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'olr', caption: 'نرخ سایر وجود قانونی', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'olam', caption: 'مبلغ سایر وجود قانونی', index: '', defaultValue: '0' },

                { type: 'text', enable: inp === '3', name: 'consfee', caption: 'اجرت ساخت', index: '', defaultValue: '0' },
                { type: 'text', enable: inp === '3', name: 'spro', caption: 'سود فروش', index: '', defaultValue: '0' },
                { type: 'text', enable: inp === '3', name: 'bros', caption: 'حق العمل', index: '', defaultValue: '0' },
                { type: 'text', enable: inp === '3', name: 'tcpbs', caption: 'جمع کل اجرت ، حق العمل  و سود', index: '', defaultValue: '0' },

                { type: 'text', enable: true, name: 'cop', caption: 'سهم نقدی از پرداخت', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'vop', caption: 'سهم مالیات بر ارزش افزوده از پرداخت', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'bsrn', caption: 'شناسه یکتای ثبت حق العمل کاری', index: '', defaultValue: '' },

                { type: 'text', enable: true, name: 'iinn', caption: 'شماره سویچ پرداخت', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'acn', caption: 'شماره پذیرنده فروشگاهی', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'trmn', caption: 'شماره پایانه', index: '', defaultValue: '' },
                {
                    type: 'select', enable: true, name: 'pmt', caption: 'روش پرداخت', index: '', defaultValue: '1', items: [
                        { value: '1', label: '1 - چک' },
                        { value: '2', label: '2 - تهاتر' },
                        { value: '3', label: '3 - وجه نقد' },
                        { value: '4', label: '4 - pos' },
                        { value: '5', label: '5 - درگاه اینترنتی' },
                        { value: '6', label: '6 - کارت به کارت' },
                        { value: '7', label: '7 - انتقال به حساب' },
                        { value: '8', label: '8 - سایر موارد' },
                    ]
                },
                { type: 'text', enable: true, name: 'trn', caption: 'شماره پیگیری', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'pcn', caption: 'شماره کارت پرداخت کننده صورتحساب', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'pid', caption: 'شماره/شناسه ملی/کد فراگیر اتباع غیر ایرانی پرداخت کننده صورتحساب', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'pdt', caption: 'تاریخ و زمان تراکنش', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'pv', caption: 'مبلغ پرداخت', index: '', defaultValue: '0' },

            ];
        }

        if (this.state.type === 13) {
            t = [
                { type: 'text', enable: true, name: 'Floor', caption: 'طبقه', index: '' },
                { type: 'text', enable: true, name: 'UnitNumber', caption: 'شماره واحد', index: '' },
                { type: 'text', enable: true, name: 'NumberPeople', caption: 'تعداد ساکنین', index: '' },
                { type: 'text', enable: true, name: 'OwnerMobile', caption: 'شماره موبایل مالک', index: '', note: 'در صورتیکه شخصی با این شماره تعریف نموده باشید، به عنوان مالک تنظیم خواهد شد' },
                { type: 'text', enable: true, name: 'CustomerMobile', caption: 'شماره موبایل مستاجر', index: '', note:'در صورتیکه شخصی با این شماره تعریف نموده باشید، به عنوان مستاجر تنظیم خواهد شد' },
                { type: 'text', enable: true, name: 'Metrag', caption: 'متراژ', index: '' },
                { type: 'text', enable: true, name: 'Phone', caption: 'خط تلفن', index: '' },
                { type: 'text', enable: true, name: 'RoomCount', caption: 'تعداد اتاق', index: '' },
                { type: 'text', enable: true, name: 'Description', caption: 'توضیحات', index: '' },
                {
                    type: 'text', enable: true, name: 'Location', caption: 'موقعیت', index: '', note: `در محتوای اکسل کد نوع موقعیت را بر اساس کد بندی زیر انجام دهید:<br/>
                    1- مسکونی
                    2- تجاری
                    3- اداری
                    4- تجاری و اداری
                    5- مسکونی و تجاری
                    6- سایر
                    ` },
                { type: 'text', enable: true, name: 'Zipcode', caption: 'کدپستی', index: '' },
                { type: 'text', enable: true, name: 'Ab', caption: 'کنترآب', index: '' },
                { type: 'text', enable: true, name: 'Barg', caption: 'کنتربرق', index: '' },
                { type: 'text', enable: true, name: 'Gaz', caption: 'کنترگاز', index: '' },
                { type: 'text', enable: true, name: 'Parking', caption: 'پارکینگ', index: '' },
                { type: 'text', enable: true, name: 'Parking2', caption: 'پارکینگ دوم', index: '' },
                { type: 'text', enable: true, name: 'Anbar', caption: 'انباری', index: '' },
                { type: 'text', enable: true, name: 'AbBillNumber', caption: 'شماره قبض آب', index: '' },
                { type: 'text', enable: true, name: 'BargBillNumber', caption: 'شماره قبض برق', index: '' },
                { type: 'text', enable: true, name: 'GazBillNumber', caption: 'شماره قبض گاز', index: '' },
                { type: 'text', enable: true, name: 'TellBillNumber', caption: 'شماره قبض تلفن', index: '' },
                { type: 'text', enable: true, name: 'Empty', caption: 'واحد خالی است؟', index: '', note:'برای واحدهای خالی در فایل اکسل عدد 1 و برای واحدهای پر عدد 0 را وارد نمایید' },
            ];
        }

        if (this.state.type === 14) {
            t = [
                { type: 'text', enable: true, name: 'Name', caption: 'نام و نام خانوادگی', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'Mobile', caption: 'موبایل', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'UserGroupsCode', caption: 'کد گروه های کاربری - با ویرگول جدا نمایید', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'NationalId', caption: 'کدملی', index: '', defaultValue: '' },
            ];
        }
        if (this.state.type === 15) {
            t = [
                { type: 'text', enable: true, name: 'Number', caption: 'شماره چک', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'Date', caption: 'تاریخ', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'Price', caption: 'مبلغ', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'Description', caption: 'شرح', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'Bank', caption: 'نام بانک', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'Branch', caption: 'شعبه', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'Sayyadi', caption: 'شماره صیادی', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'PersonCode', caption: 'کد شخص', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'Guarantee', caption: 'ضمانتی', index: '', defaultValue: '0' },
            ];
        }
        if (this.state.type === 16) {
            t = [
                { type: 'text', enable: true, name: 'Number', caption: 'شماره چک', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'Date', caption: 'تاریخ', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'Price', caption: 'مبلغ', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'Description', caption: 'شرح', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'Bank', caption: 'نام بانک', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'Sayyadi', caption: 'شماره صیادی', index: '', defaultValue: '' },
                { type: 'text', enable: true, name: 'PersonCode', caption: 'کد شخص', index: '', defaultValue: '0' },
                { type: 'text', enable: true, name: 'Guarantee', caption: 'ضمانتی', index: '', defaultValue: '0' },

            ];
        }
        return t;
    }
    setField(name, index) {
        this.state.fields.forEach(f => {
            if (f.name === name) f.index = index;
        });
    }
    setDefaultValue(name, value) {
        this.state.fields.forEach(f => {
            if (f.name === name) f.defaultValue = value;
        });
    }
    saveTemplate(e) {
        e.preventDefault();
        var body = {
            id: this.state.templateId,
            title: this.state.title,
            type: this.state.type.toString(),
            configs: JSON.stringify({
                fields: this.state.fields
            })
        }
        this.httpPost("/api/v1/excelimporttemplate/save", body)
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("الگو با موفقیت ذخیره شد");
                    this.state.templateId = data.record.id;
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.")
            });
    }
    save(e) {
        e.preventDefault();
        if (this.isBlank(this.state.file)) {
            this.showErorrMessage('لطفا فایل اکسل مورد نظر خود را اپلود نمایید');
            return;
        }
        var url = "";
        var body = {
            companyId: this.state.companyId,
            file: this.state.file,
            fields: this.state.fields
        }
        if (this.state.type === 1) {
            url = "api/v1/invoice/upload";
        }
        if (this.state.type === 2) {
            url = "api/v1/person/upload";
            body.checkMobileDuplicated = this.state.checkMobileDuplicated;
            body.checkNationalIdDuplicated = this.state.checkNationalIdDuplicated;
        }
        if (this.state.type === 3) {
            url = "api/v1/stuff/upload";
        }
        if (this.state.type === 4) {
            body.mainMoeinCode = this.state.mainMoeinCode;
            body.mainTafsilCode = this.state.mainTafsilCode;
            body.mainTafsilType = this.state.mainTafsilType;

            body.bedMoeinCode = this.state.bedMoeinCode;
            body.bedTafsilCode = this.state.bedTafsilCode;
            body.bedTafsilType = this.state.bedTafsilType;

            body.besMoeinCode = this.state.besMoeinCode;
            body.besTafsilCode = this.state.besTafsilCode;
            body.besTafsilType = this.state.besTafsilType;

            body.isBankTransaction = this.state.isBankTransaction;

            if (this.isBlank(body.mainMoeinCode)) body.mainMoeinCode = 0;
            if (this.isBlank(body.mainTafsilCode)) body.mainTafsilCode = 0;

            if (this.isBlank(body.bedMoeinCode)) body.bedMoeinCode = 0;
            if (this.isBlank(body.bedTafsilCode)) body.bedTafsilCode = 0;

            if (this.isBlank(body.besMoeinCode)) body.besMoeinCode = 0;
            if (this.isBlank(body.besTafsilCode)) body.besTafsilCode = 0;

            url = "api/v1/document/upload";
        }
        if (this.state.type === 5 || this.state.type === 6 || this.state.type === 7 || this.state.type === 8 ||
            this.state.type === 9 || this.state.type === 10 || this.state.type === 11 || this.state.type === 12) {
            url = "api/v1/invoice/upload";
        }
        if (this.state.type === 13) {
            url = "api/v1/building/unit/upload";
            body.buildingId = this.state.buildingId;
        }
        if (this.state.type === 14) {
            url = "api/v1/company/user/upload";
        }
        if (this.state.type === 15) {
            url = "api/v1/cheque/upload";
            body.type = 1;
        }
        if (this.state.type === 16) {
            url = "api/v1/cheque/upload";
            body.type = 2;
        }
        
        this.httpPost(url, body)
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ثبت شد شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.")
            });
    }
    setIsBankTransaction(e) {
        this.state.isBankTransaction = e.target.checked;

        var fields = this.state.fields;
        fields.forEach(f => {
            if (f.name === 'bed') {
                f.caption = (this.state.isBankTransaction === false ? 'مبلغ بدهکار' : 'مبلغ مانده');
            }
            if (f.name === 'bes') {
                f.enable = this.state.isBankTransaction === false;
                f.index = '';
            }
        });

        this.setState({ fields: fields, version: this.uuidv4() });
    }
    setTemplate(e) {
        var configs = JSON.parse(e.configs);
        this.setState({
            version: this.uuidv4(),
            fields: configs.fields,
            templateId: e.value,
            title: e.label
        });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">ورود اکسل اطلاعات</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <p>از طریق این بخش می تواند اطلاعات خود را به صورت دسته جمعی از طریق فایل اکسل وارد سامانه نمایید.</p>
                                        <p>برای اینکار بایستی فایل اکسل داده های مورد نظرتان را آپلود نموده و سپس مشخص نمایید که کدام ستون های فایل اکسل در سیستم بارگذاری شوند</p>
                                        <div style={{ "margin": "40px 0" }} >
                                            <input type="file" onChange={e => this.uploadFile(e)} />
                                        </div>
                                    </div>
                                </div>
                                {this.state.type === 2 && <div className="row">
                                    <div className="col-lg-12">
                                        <input onChange={e => this.state.checkMobileDuplicated = e.target.checked} defaultChecked={this.state.checkMobileDuplicated} type="checkbox" />
                                        ردیف هایی که شماره موبایل تکراری دارند یا از قبل تعریف شده اند ایمپورت نشود
                                    </div>
                                </div>}
                                {this.state.type === 2 && <div className="row">
                                    <div className="col-lg-12">
                                        <input onChange={e => this.state.checkNationalIdDuplicated = e.target.checked} defaultChecked={this.state.checkNationalIdDuplicated} type="checkbox" />
                                        ردیف هایی که شناسه ملی تکراری دارند یا از قبل تعریف شده اند ایمپورت نشود
                                    </div>
                                </div>}
                                {this.state.type === 4 && <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="documentDescription" className="title1">حساب معین اصلی<span className="text-danger">*</span></label>
                                            <input onChange={e => this.state.mainMoeinCode = parseInt(e.target.value)} defaultValue={this.state.mainMoeinCode} autocomplete="off" type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="documentDescription" className="title1">حساب تفصیل اصلی</label>
                                            <input onChange={e => this.state.mainTafsilCode = parseInt(e.target.value)} defaultValue={this.state.mainTafsilCode} autocomplete="off" type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="documentDescription" className="title1">نوع حساب تفصیل اصلی</label>
                                            <select onChange={e => this.state.mainTafsilType = parseInt(e.target.value)} defaultValue={this.state.mainTafsilType} autocomplete="off" className="form-control">
                                                <option value="-1">انتخاب نمایید ...</option>
                                                <option value="0">تفصیل عادی</option>
                                                <option value="1">مشتری و شخص</option>
                                                <option value="2">کالا و خدمات</option>
                                                <option value="3">حساب بانکی</option>
                                                <option value="4">صندوق</option>
                                                <option value="5">مرکز درآمد</option>
                                                <option value="6">مرکز هزینه</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                {this.state.type === 4 && <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="documentDescription" className="title1">حساب معین پیش فرض بدهکار<span className="text-danger">*</span></label>
                                            <input onChange={e => this.state.bedMoeinCode = parseInt(e.target.value)} defaultValue={this.state.bedMoeinCode} autocomplete="off" type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="documentDescription" className="title1">حساب تفصیل پیش فرض بدهکار</label>
                                            <input onChange={e => this.state.bedTafsilCode = parseInt(e.target.value)} defaultValue={this.state.bedTafsilCode} autocomplete="off" type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="documentDescription" className="title1">نوع حساب تفصیل پیش فرض بدهکار</label>
                                            <select onChange={e => this.state.bedTafsilType = parseInt(e.target.value)} defaultValue={this.state.bedTafsilType} autocomplete="off" className="form-control">
                                                <option value="-1">انتخاب نمایید ...</option>
                                                <option value="0">تفصیل عادی</option>
                                                <option value="1">مشتری و شخص</option>
                                                <option value="2">کالا و خدمات</option>
                                                <option value="3">حساب بانکی</option>
                                                <option value="4">صندوق</option>
                                                <option value="5">مرکز درآمد</option>
                                                <option value="6">مرکز هزینه</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                {this.state.type === 4 && <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="documentDescription" className="title1">حساب معین پیش فرض بستانکار<span className="text-danger">*</span></label>
                                            <input onChange={e => this.state.besMoeinCode = parseInt(e.target.value)} defaultValue={this.state.besMoeinCode} autocomplete="off" type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="documentDescription" className="title1">حساب تفصیل پیش فرض بستانکار</label>
                                            <input onChange={e => this.state.besTafsilCode = parseInt(e.target.value)} defaultValue={this.state.besTafsilCode} autocomplete="off" type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="documentDescription" className="title1">نوع حساب تفصیل پیش فرض بستانکار</label>
                                            <select onChange={e => this.state.besTafsilType = parseInt(e.target.value)} defaultValue={this.state.besTafsilType} autocomplete="off" className="form-control">
                                                <option value="-1">انتخاب نمایید ...</option>
                                                <option value="0">تفصیل عادی</option>
                                                <option value="1">مشتری و شخص</option>
                                                <option value="2">کالا و خدمات</option>
                                                <option value="3">حساب بانکی</option>
                                                <option value="4">صندوق</option>
                                                <option value="5">مرکز درآمد</option>
                                                <option value="6">مرکز هزینه</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>}
                                {this.state.type === 4 && <div className="row">
                                    <div className="col-lg-12">
                                        <input onChange={e => this.setIsBankTransaction(e)} defaultChecked={this.state.isBankTransaction} type="checkbox" />
                                        ورود اکسل اسناد بانکی صرفا با مبلغ مانده حساب (محاسبه خودکار مبلغ بدهکار/بستانکار)
                                    </div>
                                </div>}

                                <div className="row">
                                    <div className="col-sm-10">
                                        <div className="form-group">
                                            <label>عنوان الگو جهت ذخیره تنظیمات و استفاده مجدد</label>
                                            <input key={this.state.version} onChange={e => this.state.title = e.target.value} defaultValue={this.state.title} autocomplete="off" type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <button type="submit" onClick={e => this.saveTemplate(e)} className="btn btn-warning">
                                            ذخیره الگو
                                        </button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label className="form-label">فراخوانی الگوی ذخیره شده تنظیمات</label>
                                            <div className="form-control-wrap">
                                                <SelectAsync
                                                    defaultValue={null}
                                                    isMulti={false}
                                                    placeholder="انتخاب الگو"
                                                    components={{
                                                        DropdownIndicator: () => null,
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                    noOptionsMessage={({ inputValue }) =>
                                                        inputValue ? "نتیجه‌ای یافت نشد" : null
                                                    }
                                                    defaultOptions={[]}
                                                    loadOptions={(inputValue, callback) => this.loadExcelImportTemplatesOptions(inputValue, callback, this.state.type.toString())}
                                                    onChange={e => this.setTemplate(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist" key={this.state.version}>
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">عنوان فیلد اطلاعاتی</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">نام ستون در فایل اکسل</span></div>
                                            {(this.state.type === 4 || this.state.type === 5 || this.state.type === 6 || this.state.type === 7 || this.state.type === 8 ||
                                                this.state.type === 9 || this.state.type === 10 || this.state.type === 11 || this.state.type === 12 || this.state.type === 15 || this.state.type === 16) && <div className="nk-tb-col text-center"><span className="sub-text">مقدار پیش فرض</span></div>}
                                        </div>
                                        {this.state.fields.map((record, index) =>
                                            record.enable && <div className="nk-tb-item" key={record.name}>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.caption}</span>
                                                    <div className="text-sm" dangerouslySetInnerHTML={{ __html: record.note }}></div>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">
                                                        <input type="text" className="form-control" placeholder="برای مثال A" onChange={e => this.setField(record.name, e.target.value)} defaultValue={record.index} />
                                                    </span>
                                                </div>
                                                {(this.state.type === 4 || this.state.type === 5 || this.state.type === 6 || this.state.type === 7 || this.state.type === 8 ||
                                                    this.state.type === 9 || this.state.type === 10 || this.state.type === 11 || this.state.type === 12 || this.state.type === 15 || this.state.type === 16) && <div className="nk-tb-col">
                                                        <span className="sub-text text-center">
                                                            {record.type === "text" && <input type="text" className="form-control ms-1" placeholder="" onChange={e => this.setDefaultValue(record.name, e.target.value)} defaultValue={record.defaultValue} />}
                                                            {record.type === "select" && <select className="form-control" onChange={e => this.setDefaultValue(record.name, e.target.value)} defaultValue={record.defaultValue}>
                                                                {record.items.map(item => <option value={item.value}>{item.label}</option>)}
                                                            </select>}
                                                        </span>
                                                    </div>}
                                            </div>
                                        )}
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                بارگذاری
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        let contents =
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}